// Generated by Melange

import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function TisComponentsMobile(Props) {
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx("img", {
        className: "mt-6",
        alt: "components",
        src: StaticAsset.src("/static/images/components.svg")
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2 shrink-0",
            src: StaticAsset.src("/static/icons/check-light-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Складской учет",
            className: "paragraph text-white whitespace-pre-line"
          })
        ],
        className: "flex mt-8"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2 shrink-0",
            src: StaticAsset.src("/static/icons/check-light-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Налоговый учет и регистры",
            className: "paragraph text-white whitespace-pre-line"
          })
        ],
        className: "flex mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2 shrink-0",
            src: StaticAsset.src("/static/icons/check-light-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Работа с банком",
            className: "paragraph text-white whitespace-pre-line"
          })
        ],
        className: "flex mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2 shrink-0",
            src: StaticAsset.src("/static/icons/check-light-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Контроль подакцизных товаров",
            className: "paragraph text-white whitespace-pre-line"
          })
        ],
        className: "flex mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2 shrink-0",
            src: StaticAsset.src("/static/icons/check-light-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Учет доходов и движения денег",
            className: "paragraph text-white whitespace-pre-line"
          })
        ],
        className: "flex mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2 shrink-0",
            src: StaticAsset.src("/static/icons/check-light-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Заработная плата и управление персоналом",
            className: "paragraph text-white whitespace-pre-line"
          })
        ],
        className: "flex mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2 shrink-0",
            src: StaticAsset.src("/static/icons/check-light-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Интеграции",
            className: "paragraph text-white whitespace-pre-line"
          })
        ],
        className: "flex mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2 shrink-0",
            src: StaticAsset.src("/static/icons/check-light-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Платежный компонент",
            className: "paragraph text-white whitespace-pre-line"
          })
        ],
        className: "flex mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2 shrink-0",
            src: StaticAsset.src("/static/icons/check-light-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Безналичные платежи",
            className: "paragraph text-white whitespace-pre-line"
          })
        ],
        className: "flex mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2 shrink-0",
            src: StaticAsset.src("/static/icons/check-light-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Взаимодействие с клиентами",
            className: "paragraph text-white whitespace-pre-line"
          })
        ],
        className: "flex mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2 shrink-0",
            src: StaticAsset.src("/static/icons/check-light-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Подготовка и хранение документов",
            className: "paragraph text-white whitespace-pre-line"
          })
        ],
        className: "flex mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2 shrink-0",
            src: StaticAsset.src("/static/icons/check-light-blue.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Фискализация и передача данных на сервер ОФД",
            className: "paragraph text-white whitespace-pre-line"
          })
        ],
        className: "flex mt-2"
      })
    ]
  });
}

const make = TisComponentsMobile;

export {
  make,
}
/* react Not a pure module */
